import React from "react";
import { IoSearchOutline } from "react-icons/io5";
import profile_Img from "../../../../Assets/Images/user.png";

export default function ProfileHeader({
  setShowProfileView,
  activeChat,
  setActiveSection,
  onToggleSearch, // New prop
}) {
  return (
    <div className="px-[10px]  flex justify-between items-center w-full">
      <div
        onClick={() => {
          setActiveSection("contact");
          setShowProfileView(true);
        }}
        className="flex items-center cursor-pointer"
      >
        <img
          src={
            activeChat?.user?.mediaUrl ||
            activeChat?.user?.avtarImage ||
            activeChat?.user?.image ||
            profile_Img
          }
          alt="avatars"
          className={`${activeChat?.user?.avtarImage ||
            activeChat?.user?.image ||
            activeChat?.user?.mediaUrl
            ? "w-[46px] h-[46px] rounded-full object-cover"
            : "object-cover max-w-[46px] max-h-[46px] p-1 rounded-full"
            }`}
        />
        <div className="flex flex-col justify-start ml-3">
          <span className="cursor-pointer hover:text-[var(--primary-color)] font-semibold text-sm text-black">
            {activeChat?.user?.name}
          </span>
          {/* <div className="flex items-center space-x-1">
            <span className="w-2 h-2 bg-green-500 rounded-full"></span>
            <span className="text-xs font-normal text-[#7C7C7C] line-clamp-2 overflow-hidden text-ellipsis break-words">
              Online
            </span>
          </div> */}
        </div>
      </div>
      <button
        onClick={onToggleSearch}
        className="p-2 text-zinc-500 hover:text-indigo-600 rounded-full hover:bg-indigo-50 dark:hover:bg-indigo-500/10 transition-colors"
      >
        <IoSearchOutline size={20} />
      </button>
    </div>
  );
}
